import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const Podcast: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path d="M2,6.7c-.4,0-.8.3-.8.8v1.1c0,.4.3.8.8.8s.8-.3.8-.8v-1.1c0-.4-.3-.8-.8-.8Z" />
            <path d="M5,4.5c-.4,0-.8.3-.8.8v5.5c0,.4.3.8.8.8s.8-.3.8-.8v-5.5c0-.4-.3-.8-.8-.8Z" />
            <path d="M8,.6c-.4,0-.8.3-.8.8v13.4c0,.4.3.8.8.8s.8-.3.8-.8V1.3c0-.4-.3-.8-.8-.8Z" />
            <path d="M11,3.1c-.4,0-.8.3-.8.8v8.2c0,.4.3.8.8.8s.8-.3.8-.8V3.9c0-.4-.3-.8-.8-.8Z" />
            <path d="M14,5.7c-.4,0-.8.3-.8.8v3c0,.4.3.8.8.8s.8-.3.8-.8v-3c0-.4-.3-.8-.8-.8Z" />
        </Icon>
    );
};
